import { render } from "./RefreshSvgIcon.vue?vue&type=template&id=b62a72cc"
import script from "./RefreshSvgIcon.vue?vue&type=script&lang=js"
export * from "./RefreshSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__